import { create } from 'zustand';

import { ChatTabs, IChatState } from '@core/chat/interfaces';
import { sortByNumber } from '../../../../helpers/sort';
import { CHAT_DRAWER_WIDTH } from '@constants';

const initialChangeEventChatState = {
  open: false,
  openDeleteChatModal: false,
  initialLoading: true,
  activeTab: ChatTabs.Global,
  activePrivateChannel: null,
};

const initialChatState = {
  streamClient: null,
  eventStreamChannel: null,
  eventRoomStreamChannel: null,
  privateChannels: [],
  isUnreadEventChannel: false,
  isUnreadPrivateChannel: false,
  isUnreadEventRoomChannel: false,
  loadingPrivateChannel: null,
  resolvedFailedMessageIds: [],
  chatDrawerWidth: CHAT_DRAWER_WIDTH.THREE_TABS,
};

export const useChatState = create<IChatState>((set) => ({
  ...initialChangeEventChatState,
  ...initialChatState,
  setOpen: (open) => set({ open }),
  setStreamClient: (streamClient) => set({ streamClient }),
  setEventStreamChannel: (eventStreamChannel) => set({ eventStreamChannel }),
  setEventRoomStreamChannel: (eventRoomStreamChannel) =>
    set({ eventRoomStreamChannel }),
  setPrivateChannels: (privateChannels) => set({ privateChannels }),
  setLoadingPrivateChannel: (loadingPrivateChannel) =>
    set({ loadingPrivateChannel }),
  addPrivateChannel: (newPrivateChannel) =>
    set(({ privateChannels }) => {
      const isAlreadyExists = privateChannels.find(
        (prevChannel) => prevChannel.id === newPrivateChannel.id,
      );

      if (isAlreadyExists) return { privateChannels };

      return { privateChannels: [newPrivateChannel, ...privateChannels] };
    }),
  setIsUnreadEventChannel: (isUnread) =>
    set({ isUnreadEventChannel: isUnread }),
  setIsUnreadEventRoomChannel: (isUnread) =>
    set({ isUnreadEventRoomChannel: isUnread }),
  setIsUnreadPrivateChannel: (isUnread) =>
    set({ isUnreadPrivateChannel: isUnread }),
  setInitialLoading: (initialLoading) => set({ initialLoading }),
  setActiveTab: (activeTab) => set({ activeTab }),
  setActivePrivateChannel: (privateChannel) =>
    set({ activePrivateChannel: privateChannel }),
  resetState: () =>
    set(({ streamClient }) => ({
      ...initialChatState,
      ...initialChangeEventChatState,
      streamClient,
    })),
  resetChangeEventChatState: () =>
    set((state) => ({ ...state, ...initialChangeEventChatState })),
  setResolvedFailedMessageIds: (resolvedFailedMessageIds) =>
    set({ resolvedFailedMessageIds }),
  setOpenDeleteChatModal: (openDeleteChatModal) => set({ openDeleteChatModal }),
  setChatDrawerWidth: (chatDrawerWidth) => set({ chatDrawerWidth }),
}));
